import React from 'react';
import CyberBadge from '../common/CyberBadge';
import { Users, Lock, Unlock, ShieldCheck, Mail, Phone, Calendar } from 'lucide-react';

export default function UsersView({ users = [], onBlockUser, onUnblockUser }) {
  return (
    <div className="animate-fade" style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      {/* Header */}
      <div>
        <h1 style={{ fontSize: '1.75rem', fontWeight: 900, color: 'var(--text-primary)', letterSpacing: '-0.02em', margin: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Users size={28} style={{ color: 'var(--neon-cyan)' }} /> Platform User Directory ({users.length})
        </h1>
        <p style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', marginTop: '4px' }}>
          Manage user accounts, roles, permission controls, and security suspensions.
        </p>
      </div>

      {/* Users Table */}
      <div className="cyber-card" style={{ padding: '0', overflow: 'hidden' }}>
        <div className="table-container" style={{ border: 'none' }}>
          <table className="table">
            <thead>
              <tr>
                <th>USER NAME</th>
                <th>EMAIL / CONTACT</th>
                <th>ROLE</th>
                <th>CITY</th>
                <th>STATUS</th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {users.length === 0 ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center', padding: '40px', color: 'var(--text-muted)' }}>
                    No registered user accounts found.
                  </td>
                </tr>
              ) : (
                users.map((u) => (
                  <tr key={u._id}>
                    <td style={{ fontWeight: 800, color: 'var(--text-primary)' }}>{u.fullName || u.name || 'Platform User'}</td>
                    <td>
                      <div style={{ fontSize: '0.85rem' }}>{u.email || 'N/A'}</div>
                      <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>{u.phone || 'No phone'}</div>
                    </td>
                    <td>
                      <span className="badge badge-purple">{u.role || 'USER'}</span>
                    </td>
                    <td>{u.city || 'Indore'}</td>
                    <td>
                      <CyberBadge status={u.isBlocked ? 'blocked' : 'active'} />
                    </td>
                    <td>
                      {u.isBlocked ? (
                        <button className="btn btn-outline" style={{ padding: '6px 12px', fontSize: '0.75rem' }} onClick={() => onUnblockUser(u._id)}>
                          <Unlock size={13} /> Unblock
                        </button>
                      ) : (
                        <button className="btn btn-danger" style={{ padding: '6px 12px', fontSize: '0.75rem' }} onClick={() => onBlockUser(u._id)}>
                          <Lock size={13} /> Suspend Account
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
